/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import moment from 'moment';

import Vue from 'vue';
import { BootstrapVue, ModalPlugin } from 'bootstrap-vue'
import ClipboardJS from 'clipboard';

window.Vue = Vue;
window.ClipboardJS = ClipboardJS;

// Plugins
import i18n from './i18n';
import EventBus from "./plugins/vue-event-bus";
import Notifications from 'vue-notification';

// Directives
import VueObserveVisibility from "vue-observe-visibility";

// Components
import BlogTableBlock from './components/blog-table-block';
import CartHeader from "./components/cart-header";
import CartHeaderMobile from "./components/cart-header-mobile";
import Editor from './components/editor';
import ImagePicker from "./components/image-picker";
import Input from "./components/input";
import LinkImportTableItem from "./components/link-import-table-item";
import PackageTableBlock from "./components/package-link-table-block";
import Radio from "./components/radio";
import Select from './components/select';
import SiteTableBlock from './components/site-table-block';
import Table from "./components/table";
import Textarea from "./components/textarea";

import ProfileCompanyInfo from './components/profile-company-info';

// Modals
import CartPromotionCodeModal from './modals/cart-promotion-code-modal';

// Pages
import PageBalance from "./pages/balance";
import PageBlogs from './pages/blogs';
import PageCart from "./pages/cart";
import PageLinks from "./pages/links";
import PageLinksAdd from "./pages/links_add";
import PageLinksEdit from "./pages/links_edit";
import PageLinksImport from "./pages/links_import";
import PagePackages from './pages/packages';
import PagePackagesAdd from './pages/packages_add';
import PagePosts from "./pages/posts";
import PagePostsAdd from "./pages/posts_add";
import PagePostsEdit from "./pages/posts_edit";
import PageRegister from './pages/register';
import PageSites from './pages/sites';

import route from './route';
import store from './store';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Plugins
Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(EventBus);
Vue.use(Notifications);

// Directives
Vue.use(VueObserveVisibility);

// Prototypes
Vue.prototype.moment = moment;
Object.defineProperty(Vue.prototype, '$_', { value: _ });
Object.defineProperty(Vue.prototype, '$route', { value: route })

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Cart
Vue.component('bs-cart-header', CartHeader);
Vue.component('bs-cart-header-mobile', CartHeaderMobile);

Vue.component('bs-blog-table-block', BlogTableBlock);
Vue.component('bs-editor', Editor);
Vue.component('bs-image-picker', ImagePicker);
Vue.component('bs-input', Input);
Vue.component('bs-package-table-block', PackageTableBlock);
Vue.component('bs-radio', Radio);
Vue.component('bs-select', Select);
Vue.component('bs-site-table-block', SiteTableBlock);
Vue.component('bs-textarea', Textarea);

Vue.component('bs-table', Table);

Vue.component('bs-link-import-table-item', LinkImportTableItem);

Vue.component('bs-profile-company-info', ProfileCompanyInfo);

// Modals
Vue.component('bs-cart-promotion-code-modal', CartPromotionCodeModal);


Vue.filter('currency', function (value) {
  var formatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR'
  });

  return isNaN(value) ? value : formatter.format(parseFloat(value));
});

Vue.filter('date', function(value, format = "DD-MM-YYYY") {
  if (!value) return value;
  
  return moment(value).format(format);
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});

window.app = new Vue({
    el: '#app',
    i18n,
    store,
    components: {
      'page-balance': PageBalance,
      'page-blogs': PageBlogs,
      'page-cart': PageCart,
      'page-links-add': PageLinksAdd,
      'page-links-edit': PageLinksEdit,
      'page-links-import': PageLinksImport,
      'page-links': PageLinks,
      'page-packages-add': PagePackagesAdd,
      'page-packages': PagePackages,
      'page-posts-add': PagePostsAdd,
      'page-posts-edit': PagePostsEdit,
      'page-posts': PagePosts,
      'page-register': PageRegister,
      'page-sites': PageSites,
      // 'page-links-extend': PageLinksExtend,
    }
});
